import { RouteController } from '@bymason-private/route-provider';
import { LinearProgress } from '@bymason-private/legacy-pattern-components';
import { defaultRoute, loginRoute, logoutRoute, unvalidatedRoute, routes } from './routes';
import { ControllerVersion, useSelectedControllerPref } from '../global-state/hooks';
import { useEffect, useState } from 'react';
import { useAuth } from '@bymason-private/auth-provider';

export * from './routes';

export default function ControllerRouter() {
  const { userInfo } = useAuth();
  const [selectedControllerVersion] = useSelectedControllerPref();

  const [showLoading, setShowLoading] = useState(true);

  useEffect(() => {
    if (window.location.pathname.startsWith('/controller2/signup')) {
      const signupUrl = window.location.href
        .replace('/controller2', '/controller')
        .replace('localhost:3001', 'localhost:3003');
      window.location.href = signupUrl;
    }
  }, []);

  useEffect(() => {
    if (selectedControllerVersion === ControllerVersion.ControllerV2) {
      setShowLoading(true);
      console.log('Controller v2 is the prefered app. Redirecting to Controller v2');
      const v2Url = window.location.href
        .replace('/controller2', '/controller')
        .replace('localhost:3001', 'localhost:3003');
      window.location.href = v2Url;
    } else {
      setShowLoading(false);
    }
  }, [selectedControllerVersion]);

  useEffect(() => {
    window.zE('webWidget', 'hide');
    window.zE('webWidget', 'open');
    window.zE('webWidget:on', 'close', function () {
      window.zE('webWidget', 'hide');
      window.zE('webWidget', 'open');
      window.zE('webWidget', 'reset');
    });
  }, []);

  useEffect(() => {
    if (userInfo && userInfo?.email_verified && userInfo.email) {
      window.Sprig('setUserId', userInfo.user_id);
      window.Sprig('setEmail', userInfo.email);
      window.heap.identify(userInfo.user_id);
      window.heap.addUserProperties({ email: userInfo.email });
      window.zE('webWidget', 'identify', {
        name: userInfo.name,
        email: userInfo.email,
      });
      window.zE('webWidget', 'prefill', {
        name: { value: userInfo.name },
        email: { value: userInfo.email },
      });
    }
  }, [userInfo]);

  return (
    <RouteController
      busyComponent={<LinearProgress color='primary' />}
      defaultRoute={defaultRoute}
      loginRoute={loginRoute}
      logoutRoute={logoutRoute}
      unvalidatedRoute={unvalidatedRoute}
      routes={routes}
      showLoading={selectedControllerVersion === undefined || showLoading}
    />
  );
}
